import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Row, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Calendar from "react-calendar";

import "react-calendar/dist/Calendar.css";
import "./style.scss";
import moment from "moment";
import { isEmpty } from "lodash";
import { useSearchParams } from "react-router-dom";

const propTypes = {
  filter: PropTypes.func,
  setCategory: PropTypes.func,
  setDate: PropTypes.func,
  setKeyword: PropTypes.func,
  setPriceRange: PropTypes.func,
  date: PropTypes.string,
  keyword: PropTypes.string,
  priceRange: PropTypes.string,
};

const Filter = ({
  filter,
  priceRange,
  setPriceRange,
  setDate,
  date,
  setKeyword,
  keyword,
}) => {
  const { t } = useTranslation();

  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchParams] = useSearchParams();

  const onChange = (date) => {
    setDate(date);
    setShowCalendar(false);
  };

  const categories = [
    {
      value: "5",
      title: "all_categories",
    },
    {
      value: "0",
      title: "accommodation",
    },
    {
      value: "1",
      title: "activity",
    },
    {
      value: "2",
      title: "restaurant",
    },
  ];

  const priceRanges = [
    {
      value: "1-9999",
      title: "~ 9.999円",
    },
    {
      value: "10000-14999",
      title: "10.000円 ~ 14.999円",
    },
    {
      value: "15000-19999",
      title: "15.000円 ~ 19.999円",
    },
    {
      value: "20000-",
      title: " 20.000円 ~",
    },
  ];

  useEffect(() => {
    const categoryParams = searchParams.get("category");
    categoryParams && setSelectedCategories([...categoryParams.split(",")]);
  }, [searchParams]);

  const selectCategory = (e) => {
    const { checked, value } = e.currentTarget;

    if (value === "5") {
      setSelectedCategories([]);
    } else {
      setSelectedCategories((prev) =>
        checked ? [...prev, value] : prev.filter((val) => val !== value)
      );
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const numberCategories = !isEmpty(selectedCategories)
      ? selectedCategories.map((x) => parseInt(x)).sort((a, b) => a - b)
      : [0, 1, 2];
    const data = {
      date: event.target[0].value ? new Date(event.target[0].value) : null,
      category: numberCategories,
      minRange: priceRange?.includes("-") ? priceRange?.split("-")[0] : null,
      maxRange:
        priceRange?.split("-")[1] && priceRange?.includes("-")
          ? priceRange?.split("-")[1]
          : null,
      keyword,
    };
    setShowCalendar(false);
    filter(data);
  };

  const minDate = () => {
    const someDate = new Date();
    const numberOfDaysToAdd = 2;
    const result = someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
    return new Date(result);
  };
  return (
    <div className="filterWrapper">
      <div className="filterTitle">{t("filter")}</div>
      <form onSubmit={handleSubmit}>
        <Row>
          <div className="col-12 col-lg-6 mb-3 ">
            <Form.Control
              type="input"
              name="date"
              placeholder={t("date_placeholder")}
              readOnly
              value={date && moment(date).format("LL")}
              onClick={() => setShowCalendar(!showCalendar)}
            />
            <Calendar
              minDate={minDate()}
              onChange={(date) => onChange(date)}
              value={date}
              className={!showCalendar ? "hide" : ""}
            />
            <small className="clearDate mt-1" onClick={() => setDate("")}>
              <a href="#">{t("clear_date")}</a>
            </small>
          </div>
          <div className="col-12 col-lg-6 mb-3 ">
            <Form.Control
              type="text"
              name="keyword"
              onChange={(e) => setKeyword(e.target.value)}
              placeholder={t("keyword")}
              value={keyword}
            />
          </div>
          <div className="col-12 col-lg-6 mb-3 d-none">
            <div className="d-flex flex-wrap">
              {categories.map((item, i) => {
                return (
                  <div className="form-check" key={i}>
                    <label className="form-check-label">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        name="categories"
                        checked={
                          item.value === "5"
                            ? selectedCategories.length === 0
                            : selectedCategories.includes(item.value)
                        }
                        value={item.value}
                        onChange={(e) => selectCategory(e)}
                      />
                      {t(item.title)}
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col-12 mb-3 ">
            <div className="d-flex flex-wrap">
              <div className="form-check">
                <label className="form-check-label">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="categories"
                    value="0-"
                    onChange={() => setPriceRange("0-")}
                    checked={priceRange === "0-"}
                  />
                  {t("price_range")}
                </label>
              </div>
              {priceRanges.map((item, i) => {
                return (
                  <div className="form-check" key={i}>
                    <label className="form-check-label">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="categories"
                        value={item.value}
                        onChange={() => setPriceRange(item.value)}
                        checked={priceRange === item.value}
                      />
                      {item.title}
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col-12 buttonWrapper">
            <Button variant="primary" type="submit">
              {t("search")}
            </Button>
          </div>
        </Row>
      </form>
    </div>
  );
};

Filter.propTypes = propTypes;

export default Filter;
